import { autoplay, platform, StateController } from "@aceroll/core";

// services
import { sounds } from "../services";

class IdleController extends StateController {
    constructor() {
        super("idle");
        this._initial = false;
    }

    onStart() {
        if (!this._initial) {
            this._initial = true;
            sounds.subscribeUISounds();
            sounds.setBaseAmbient(1500);
        }

        if (sounds.levelPlaying) {
            sounds.levelPlaying = false;
            sounds.setBaseAmbient(750);
        }

        if (autoplay.isStarted()) {
            return this.stop();
        }

        platform.onceRoundStarted()
            .then((data) => {
                this.stop();
            });
    }

    onStop() { }
}

export default IdleController;